import { render, staticRenderFns } from "./FieldSelectModal.vue?vue&type=template&id=ddea3e64&scoped=true&"
import script from "./FieldSelectModal.vue?vue&type=script&lang=ts&"
export * from "./FieldSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./FieldSelectModal.vue?vue&type=style&index=0&id=ddea3e64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddea3e64",
  null
  
)

export default component.exports